import { Grid, Skeleton, Typography } from "@mui/material";
import { BrandBlackLogo } from "components/layout/print/BrandBlackLogo";
import { Sx } from "utils/sx";

export const PriorityJudgePageSkeleton = () => (
    <>
        <Grid
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                position: "relative",
                justifyContent: "center",
            }}
        >
            <Grid sx={(theme) => ({ display: "flex", justifyContent: "space-between", p: theme.spacing(1, 2) })}>
                <Grid size={4} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <BrandBlackLogo />
                    <Typography variant="button2">
                        <Skeleton width={80} variant="text" />
                    </Typography>
                </Grid>
                <Grid size={4} sx={{ display: "flex", alignItems: "center" }}>
                    <Typography variant="monoTimerXxl">
                        <Skeleton width={80} variant="text" />
                    </Typography>

                </Grid>
                <Grid size={4} sx={{ display: "flex", alignItems: "center" }}>
                    <Skeleton variant="circular" width={40} height={40} />
                </Grid>
            </Grid>
        </Grid>
        <Grid
            sx={(theme) => ({
                display: "flex",
                flexDirection: "column",
                padding: theme.spacing(1),
            })}>
            {[1, 2, 3, 4].map((_,i ) => {
                return (
                    <Grid
                        key={i}
                        container
                        sx={{
                            display: "flex",
                            gap: 1.5,
                            flexWrap: "nowrap",
                        }}>
                        {[1,4,1,2,2,2,2].map((size, i) => {
                            const skeletonStyles: Sx = theme => ({
                                width: "100%",
                                height: theme.spacing(7.5),
                                mb: 1.5
                            });

                            if(i === 0) {
                                return (
                                    <Grid key={i} size={1}>
                                        <Typography textAlign="center" variant="h2" sx={(theme) => ({ display: "flex" , alignItems: "center", justifyContent: "center", width: "100%", height: theme.spacing(7.5), })}>
                                            <Skeleton width={100} variant="text" />
                                        </Typography>
                                    </Grid>);
                            };

                            if(i === 1) {
                                return (
                                    <Grid key={i} size={3}>
                                        <Skeleton
                                            variant="rectangular"
                                            sx={skeletonStyles}
                                        />
                                    </Grid>);
                            }

                            return (
                                <Grid key={i} size={size}>
                                    <Skeleton
                                        variant="rounded"
                                        sx={skeletonStyles}
                                    />
                                </Grid>);
                        })}
                    </Grid>);
            })}
        </Grid>
    </>
);
